export default __webpack_public_path__ + "static/media/logo.23aabe82.jpeg";